import React from 'react'
import styles from './HandHistory.module.css';
import { Sheet, SheetContent, SheetTrigger } from '../ui/sheet';
import { MdOutlineHistory } from "react-icons/md";
// import GameIconButton from '../GameIconButton/GameIconButton';
import { GameIconButton } from '@themed-components';

// Example mock data
const mockHands = [
    { id: 1, date: '2024-06-01', result: '+₹250', hand: 'AK♠️ vs QQ♦️' },
    { id: 2, date: '2024-06-01', result: '-₹100', hand: 'J9♣️ vs 77♥️' },
    { id: 3, date: '2024-05-31', result: '+₹500', hand: 'AA♠️ vs KK♦️' },
];

export default function HandHistory({ tempTableId }) {
    // Replace mockHands with real data when available
    const hands = mockHands; // or [] for empty state

    return (
        <Sheet>
            <SheetTrigger className={styles.filterButton}>
                <GameIconButton>
                    <MdOutlineHistory />
                </GameIconButton>
            </SheetTrigger>
            <SheetContent side="left" className={styles.gameMenuSheetContent}>
                <div className={styles.header}>Hand History</div>
                <div className={styles.list}>
                    {hands.length === 0 ? (
                        <div className={styles.empty}>No hands played yet.</div>
                    ) : (
                        hands.map(hand => (
                            <div key={hand.id} className={styles.handItem}>
                                <div className={styles.handDate}>{hand.date}</div>
                                <div className={styles.handInfo}>{hand.hand}</div>
                                <div className={styles.handResult}>{hand.result}</div>
                            </div>
                        ))
                    )}
                </div>
            </SheetContent>
        </Sheet>
    )
}
